export default "__VITE_ASSET__c2e1f740__"